// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3ohoW","head":"ProcedureTableInfo_head__1keGZ"};